import { createRange } from '@libs/utils';

import { toJalali } from '@/components/Datepicker/convertor';

const MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
] as const;

const MINUTE_PER_MILLISECOND = 60000;

const DEFAULT_DATE = {
  year: 1390,
  month: 0,
  day: 1,
};

const YEARS = (() => {
  const date = new Date();
  const [year] = toJalali(date.getFullYear(), date.getMonth(), date.getDate());

  return createRange(DEFAULT_DATE.year, year);
})();

export { MONTHS, YEARS, MINUTE_PER_MILLISECOND, DEFAULT_DATE };
